/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from '@tanstack/react-router';
import { Users, Video, LogOut, User } from 'lucide-react';

import { useCallback } from 'react';

// Components
import { Sidebar } from '@/components/Sidebar/Sidebar';

// Hooks
import { useLogout } from '@/hooks/logout.hook';

// Types
import { DashboardTab } from '@/constants/tabs.constants';

/* -------------------------------------------------------------------------- */
/*                                   Layout                                   */
/* -------------------------------------------------------------------------- */
export default function DashboardLayout() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onLogoutSuccess = () => {
    navigate({ to: '/auth/login' });
  };
  const { mutate } = useLogout({ onSuccess: onLogoutSuccess });

  const location = useLocation();

  const determineActiveTab = useCallback(() => {
    if (
      location.pathname.includes('/dashboard') ||
      location.pathname.includes('/beneficiaries')
    )
      return DashboardTab.BENEFICIARIES;
    if (location.pathname.includes('/meetings')) return DashboardTab.MEETINGS;
    if (location.pathname.includes('/profile')) return DashboardTab.PROFILE;
  }, [location.pathname]);

  const topItems = [
    {
      icon: Users,
      label: t('global.beneficiaries'),
      onClick: () => {
        navigate({ to: '/dashboard' });
      },
      isSelected: determineActiveTab() === DashboardTab.BENEFICIARIES,
    },
    {
      icon: Video,
      label: t('global.meetings'),
      onClick: () => {
        navigate({ to: '/meetings' });
      },
      isSelected: determineActiveTab() === DashboardTab.MEETINGS,
    },
  ];

  const bottomItems = [
    {
      icon: User,
      label: t('global.profil'),
      onClick: () => {
        navigate({ to: '/profile' });
      },
    },
    {
      icon: LogOut,
      label: t('global.logout'),
      onClick: () => {
        mutate();
      },
      isSelected: false,
    },
  ];

  return (
    <div className="flex h-screen bg-white">
      <Sidebar
        title={t('global.menu')}
        topItems={topItems}
        bottomItems={bottomItems}
      />
      <main className="flex-1 p-8 overflow-auto text-white">
        <Outlet />
      </main>
    </div>
  );
}
